import React from 'react'
import OnboardingCompleted from '../../components/Onboarding/Intro/OnBoardingCompleted'

const SpeakToConsultantCompletedPage = () => {
  return <OnboardingCompleted />
}

export default SpeakToConsultantCompletedPage
